import { enIN } from 'date-fns/locale';
import { Field, Formik, Form as FormikForm } from 'formik';
import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { registerLocale } from 'react-datepicker';
import { DateFormatNew } from '../../../constants/date-picker-constant';
import { AddEditHolidayInitialState } from '../../../core/initialState';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import { IAddHoliday } from '../../../models/forms/IAddEditHoliday';
import { IAddEditFormProps } from '../../../models/forms/IForm';
import FormikFormDatePicker from '../../../shared-components/FormikFormHandlers/FormikFormDatePicker';
import FormikFormInput from '../../../shared-components/FormikFormHandlers/FormikFormInput';
import FormikFormTextArea from '../../../shared-components/FormikFormHandlers/FormikFormTextArea';
import { HolidayCalendarValidationSchema } from '../../../shared-components/FormikFormHandlers/FormikValidationSchema';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';
import { formatMessage } from '../../../translations/format-message';

registerLocale('en-IN', enIN);

interface IProps extends IAddEditFormProps<any> {
  selectedYear: number;
  selectedDate: Date;
}
const AddEditHolidayCalendarForm = (props: IProps) => {
  return (
    <React.Fragment>
      <Formik
        initialValues={{
          ...AddEditHolidayInitialState,
          HolidayDate: props.selectedDate,
        }}
        enableReinitialize
        validationSchema={HolidayCalendarValidationSchema}
        validateOnBlur={false}
        onSubmit={async (values: IAddHoliday, { resetForm, setFieldValue }) => {
          const date = new Date(values.HolidayDate);
          const localDate = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
          );
          const formattedDate = localDate.toISOString().split('T')[0];

          props.submitHandler({
            ...values,
            TenantId: Number(getTenantIdFromLocalStorage()),
            HolidayDate: formattedDate,
            Year: date.getFullYear(),
          });
          resetForm();
        }}
      >
        {() => {
          return (
            <FormikForm className="user-form">
              {props.isLoading ? (
                <FormLoader loading={props.isLoading} />
              ) : null}
              <Form.Group controlId="dateRange">
                <Form.Group
                  className="mb-3"
                  controlId="date"
                >
                  <Label
                    className="label-style col-form-label"
                    required={true}
                    label="date"
                  />
                  <Field
                    data-testid="date"
                    className="form-control"
                    name="HolidayDate"
                    value={new Date()}
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    // dateFormat={
                    //   navigator.languages?.some((lang) =>
                    //     ['ja-JP', 'ja', 'zh-CN', 'zh'].includes(lang)
                    //   )
                    //     ? DateFormatForDatePickerJP
                    //     : DateFormat
                    // }
                    dateFormat={DateFormatNew}
                    minDate={new Date(props.selectedYear, 0, 1)}
                    maxDate={new Date(props.selectedYear, 11, 31)}
                    as={FormikFormDatePicker}
                    calendarStartDay={0}
                  />
                </Form.Group>

                <Form.Group
                  className="mb-3"
                  controlId="skuFilter"
                >
                  <Label
                    className="label-style"
                    required={false}
                    label="name"
                  />
                  <Field
                    data-testid="name"
                    className="form-control"
                    name="HolidayName"
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    as={FormikFormInput}
                  />
                </Form.Group>

                <Form.Group
                  className="mb-3"
                  controlId="skuFilter"
                >
                  <Label
                    className="label-style"
                    label="comment"
                  />
                  <Field
                    id="Comment"
                    className="form-control"
                    name="Comment"
                    placeholder=""
                    type="text"
                    as={FormikFormTextArea}
                  />
                </Form.Group>
              </Form.Group>
              <div className="text-end">
                <Button
                  variant="primary"
                  type="submit"
                  className=""
                >
                  {formatMessage('save')}
                </Button>
              </div>
            </FormikForm>
          );
        }}
      </Formik>
    </React.Fragment>
  );
};

export default AddEditHolidayCalendarForm;
